<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <h2>Objetivos</h2>
      </div>
      <div class="modal-body text-sm">
        <h5>Instrucciones</h5>
        <p>
          <b>Cumplimiento (%):</b> Indica el porcentaje de cumplimiento de cada objetivo en la celda designada.
          Utiliza un número del 0% al 100% para reflejar el progreso de cada objetivo.
        </p>
        <p>
          Encontrarás las secciones de cumplimiento, registrarás el cumplimiento intermedio de los objetivos equivalentes al periodo en que se agrega el cumplimiento desde el inicio del año, y a final de año.
        </p>
      </div>
      <div class="modal-footer">
        <button class="close-modal-btn" @click="$emit('close')">
          Cerrar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  width: 80%;
  max-width: 600px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-header {
  background: #1d4745 !important;
  color: white;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

.modal-body {
  padding: 20px;
  font-size: 12px;
  color: #333;
  line-height: 1.5;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #ddd;
}

.close-modal-btn {
  background-color: #1d4745;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 13px;
}

.close-modal-btn:hover {
  background-color: #163a38;
}
</style>
